/**
 * Mute/play state for autoplaying background videos, driving the sound + pause
 * control pair in `snippets/hero-controls.liquid` (which reads/writes
 * `videoMuted` / `videoPlaying` in this scope).
 *
 * `videoControlsState()` and `bindVideoControls()` are the shared building
 * blocks so `videoWrapper` can layer its autoplay strategy on top of the same
 * mute/play behaviour. Put the component on the element that wraps the <video>
 * tags so `$el.querySelectorAll` scopes to this block's videos:
 *   x-data="videoControls"   (controls only)
 *   x-data="videoWrapper"    (controls + robust autoplay — preferred)
 */
export const videoControlsState = () => ({
  videoMuted: true,
  videoPlaying: true,
});

export const bindVideoControls = (ctx) => {
  ctx.$watch('videoPlaying', (playing) => {
    ctx.$el.querySelectorAll('video').forEach((video) => {
      if (video.offsetParent === null) return;
      playing ? video.play().catch(() => {}) : video.pause();
    });
  });

  ctx.$watch('videoMuted', (muted) => {
    // Only toggle audio on the currently visible video (desktop vs mobile).
    ctx.$el.querySelectorAll('video').forEach((video) => {
      if (video.offsetParent !== null) video.muted = muted;
    });
  });
};

export default () => ({
  ...videoControlsState(),
  init() {
    bindVideoControls(this);
  },
});
